var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"end-content",attrs:{"id":"train-result-data-after"}},[_c('KCListAndDetail',{attrs:{"tableData":_vm.tableData,"kcList":_vm.kcList,"selectHandler":_vm.selectHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }